"use client";

import { ReactNode } from "react";
import { container, LandingServiceID } from "@/lib/store/di.config";
import { LandingStoreContext } from "@/lib/store/landing-store.context";
import type { ILandingRootStore } from "@/lib/store/landing-root.store";

const store = container.get<ILandingRootStore>(LandingServiceID.RootStore);

export function LandingStoreProvider({ children }: { children: ReactNode }) {
  return (
    <LandingStoreContext.Provider value={store}>
      {children}
    </LandingStoreContext.Provider>
  );
}
